<div class="col-xs-12">
    <div class="orderheaderseason">{{dropdownValue.replace('-20','/')}} {{"myMaterial.seasonLabel" | cxTranslate}}</div>
    <div class="d-none orderseasonsubheader">{{"myMaterial.subText" | cxTranslate}}</div>
</div>
<div class="col-lg-5 col-md-5 col-sm-12 col-12 open-order float_left" id="leftsection">
    <div class="form-group">
        <div class="col-md-8 col-lg-8 col-sm-8 col-8 no-padding for_tab_view float_left">
            <div class="input-group seach_order">
                <div class="input-group-addon">
                    <i class="fa fa-search"></i>
                </div>
                <input (keyup)="inputsearch($event);applyFilter()" class="form-control" id="open_order_search"
                    name="lookup" type="text" [(ngModel)]="valformsummary">
            </div>
        </div>
        <div class="col-md-1 col-2 filterbox float_left" (click)="filteropen()">
            <span class="select_counter">{{count}}</span><span class="filter_txt">{{"myMaterial.filterLabel" | cxTranslate}}</span>
        </div>
        <div class="col-md-1 col-2 sortbox float_left" (click)="sortopen()"
                [ngClass]="togglesortView?'open':''"> <span
                class="filter_txt">{{"myMaterial.sortLabel" | cxTranslate}}</span></div>


        <div class="filteropen" (click)="onFilterClick($event)" [ngClass]="togglefilterView?'open':''">

            <div class="statussection">
                <div class="filterheader">{{"myMaterial.byStatustext" | cxTranslate}}</div>
                <div>
                    @for( list of getstatus?.seqirusOrderStatusList;track list;let i=$index){
                    <div class="col-md-12 no-padding"
                       >
                        <label> <input type="checkbox" class="registration_checkbox" value={{list}}
                                (click)="incrementcountstatus($event,i);applyFilter()"
                                [checked]="filterValues.filterbystatus.includes(list)"> <span
                                class="checkbox-button__control"></span>{{list}}</label>
                    </div>
                }

                </div>


            </div>
            <div class="invoice_reset" id="invoice_resetfilter" (click)="resetFilter()">
                {{"myMaterial.resetLabel" | cxTranslate}}
            </div>
        </div>
        <div class="sortopen" (click)="onFilterClick($event)" [ngClass]="togglesortView?'open':''">
            <div class="sortcont">
                <div>
                    <div class="col-md-6 no-padding floatleftuk">
                        <div class="filterheader">{{"myMaterial.orderNoText" | cxTranslate}}</div>
                        <label> <input type="radio" class="registration_radio" name="radiobtn" value="1to9"
                                (click)="sortTest('1to9')" [checked]="sortvalue=='1to9'?'checked':''"> <span
                                class="radio-button__control"></span>1 To 9</label> <label> <input type="radio"
                                class="registration_radio" name="radiobtn" value="9to1" (click)="sortTest('9to1')"
                                [checked]="sortvalue=='9to1'?'checked':''"> <span class="radio-button__control"></span>9
                            To 1</label>
                    </div>
                    <div class="col-md-6 no-padding floatleftuk">
                        <div class="filterheader">{{"myMaterial.locLabel" | cxTranslate}}</div>
                        <label> <input type="radio" class="registration_radio" name="radiobtn" value="AtoZ"
                                (click)="sortTest('AtoZ')" [checked]="sortvalue=='AtoZ'?'checked':''"> <span
                                class="radio-button__control"></span>A To Z</label> <label> <input type="radio"
                                class="registration_radio" name="radiobtn" value="ZtoA" (click)="sortTest('ZtoA')"
                                [checked]="sortvalue=='ZtoA'?'checked':''"> <span class="radio-button__control"></span>Z
                            To A</label>

                    </div>
                </div>
                <br>
                <div>
                    <div class="col-md-12 floatleftuk no-padding">
                        <div class="filterheader">{{"myMaterial.datePlacedLabel" | cxTranslate}}</div>
                        <label> <input type="radio" class="registration_radio" name="radiobtn" value="MostRecent"
                                (click)="sortTest('MostRecent')" [checked]="sortvalue=='MostRecent'?'checked':''"> <span
                                class="radio-button__control"></span> {{"myMaterial.mostRecLabel" | cxTranslate}}</label> <label> <input type="radio"
                                class="registration_radio" name="radiobtn" value="LeastRecent"
                                (click)="sortTest('LeastRecent')" [checked]="sortvalue=='LeastRecent'?'checked':''">
                            <span class="radio-button__control"></span>{{"myMaterial.leastRecLabel" | cxTranslate}}</label>


                    </div>
                </div>
            </div>
            <div class="invoice_reset " id="invoice_resetfilter" (click)="resetsort()">
                {{"myMaterial.resetLabel" | cxTranslate}}
            </div>

        </div>


    </div>

    <div class="clearfix"></div>

    <hr>
@if(isLoading){
    <div  class="loading">
        <div class="loading_txt">
            <div class="load_txt">{{"myMaterial.loadingTxt" | cxTranslate}}</div>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
    </div>
}
@if(!isLoading){
    <div >
        <div class="mat-elevation-z8 " id="orderfiltertable">
            <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
                <ng-container matColumnDef="combined">
                    <th class="odertableheader" mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element" (click)="openRightSection(element.orderId)">
                        <div class="tablecolum_order1">
                            <span class="season_text">{{element.season.replace('-20','/')}} {{"myMaterial.seasonLabel" | cxTranslate}}</span>
                            <div class="order_id">{{"myMaterial.orderNoLabel" | cxTranslate}} {{element.orderId}}</div>
                            <div class="order_unit"><span class="left-font">{{"myMaterial.placedOnLabel" | cxTranslate}}:</span><span
                                    class="totalorderquantity_Order left-font"
                                    [className]=element.orderId>{{element.orderDate}}</span></div>

                            <div class="order_unit"><span class="left-font">{{"myMaterial.itemsLabel" | cxTranslate}}:</span><span
                                    class="totalorderquantity_Order left-font"
                                    [className]=element.orderId>{{element.items | number:'1.0-0'}}</span></div>

                            <div class="order_location "><span class="left-font">{{"myMaterial.delLocLabel" | cxTranslate}}</span>
                                <span class="order_substaus">
                                    {{element.delLocation}}</span>
                            </div>
                        </div>
                        <div class="order_status"
                            [ngClass]="element.status != 'Delivered' ? element.status== 'Pre-Ordered'?'pre-ordered':'status_ord_pending' : 'status_ord_complete'">
                            {{element.status}}</div>
                    </td>


                </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row id="{{row.orderId}}" [class.activeorder]="row.orderId == selectedorderactive" *matRowDef="let row; columns: displayedColumns;"></tr>
                <tr class="mat-row " *matNoDataRow>
                    <td class="mat-cell no-matching">{{"myMaterial.noDatatext" | cxTranslate}}</td>
                </tr>
            </table>

            <div class="custom-paginator">
                <button class="pagination-buttonOrg" (click)="goToFirstPage()" [disabled]="isFirstPage()">
                    <img alt="Navigate to previous page" src="assets/images/pagination-double-prev-arrow-icon.svg"
                        class="locations_arrows">
                </button>
                <button class="pagination-buttonOrg" (click)="previousPage()" [disabled]="isFirstPage()">
                    <img alt="Navigate to previous page" src="assets/images/pagination-prev-btn.svg"
                        class="locations_arrows">
                </button>
                @for( pge of getPages();track pge){
                <button class="pagination-buttonOrg" 
                    [class.active-page]="isCurrentPage(pge)" (click)="goToPage(pge)">
                    {{pge}}
                </button>
            }
                <button class="pagination-buttonOrg" (click)="nextPage()" [disabled]="isLastPage()">
                    <img alt="Navigate to next page" src="assets/images/pagination-next-btn.svg"
                        class="locations_arrows">
                </button>
                <button class="pagination-buttonOrg" (click)="goToLastPage()" [disabled]="isLastPage()">
                    <img alt="Navigate to last page" src="assets/images/pagination-double-next-arrow-icon.svg"
                        class="locations_arrows">
                </button>
            </div>
        </div>
    </div>
}
</div>
<div class="mobileright" id="rightsection">
    @if(!isLoading && firstvalue){
    <div >
        <div class="col-lg-7 col-md-7 col-span-12 right-order  order-details-view float_left ">

            @if(rightsectionresponse){
                <div class="order_details_section col-md-12" id="{{rightsectionresponse.materialsOrderData[0].orderId}}">
                    <div class="order_status_table">
                        <div class="row order_panel_header right-first-row">
                            <div class="col-md-4 col-xs-8">
                                <div class="order_id">
                                    {{"myMaterial.orderNoLabel" | cxTranslate}}<span class="order_id_fetch">{{rightsectionresponse.materialsOrderData[0].orderId}}</span>
                                </div>

                            </div>
                            <div class="col-md-4 col-xs-4">
                                <div class="current_order_status">
                                    {{rightsectionresponse.materialsOrderData[0].status}}
                                </div>

                            </div>

                            <div class="col-md-12 contact_inst">
                                <div class="contact_order_txt" [innerHTML]="'myMaterial.customerServiceText' | cxTranslate">
                                </div>
                            </div>

                        </div>
                        
                        <div class="row order_panel_header">
                            <div class="col-md-2 col-3">
                                <div class="order_status_header">{{"myMaterial.placedOnLabel" | cxTranslate}}</div>
                                <div class="order_substaus">
                                    {{rightsectionresponse.materialsOrderData[0].orderDate}}</div>
                            </div>

                            <div class="col-md-5 col-12 mobile_MT">
                                <div class="order_status_header">{{"myMaterial.delAddrLabel" | cxTranslate}}</div>
                                <div class="order_substaus">
                                    {{rightsectionresponse.materialsOrderData[0].delLocation}}</div>
                            </div>
                        </div>

                        <div class="row order_panel_header no-border-B">
                            <div class="col-xs-12 col-md-6">
                                <div class="order_status_header quantity_header">{{"myMaterial.materialDelText" | cxTranslate}}</div>
                                <div class="order_substaus margin-T10 margin-B20">
                                     <strong class="crnt-ord"><span class="crnt_order_qty">{{rightsectionresponse.materialsOrderData[0].deliveredDose | number:'1.0-0'}}</span>
                                    items</strong> / <span class="total_qty total_qty0">{{rightsectionresponse.materialsOrderData[0].items | number:'1.0-0'}}</span>
                                </div>
                                <div class="progress progressUS progressUK">
                                    <mat-progress-bar mode="determinate" value= {{getProgress(rightsectionresponse.materialsOrderData[0].deliveredDose,rightsectionresponse.materialsOrderData[0].items)}}></mat-progress-bar>
                                </div>
                            </div>

                        </div>
                        <div class="order_panel_header no-padding-bottom">
                            <mat-accordion multi="true">
                                @if(digitalMaterialsList?.length > 0){
                                <mat-expansion-panel >
                                  <mat-expansion-panel-header>
                                    <mat-panel-title>{{"myMaterial.digMaterialLabel" | cxTranslate}}</mat-panel-title>
                                  </mat-expansion-panel-header>
                                  <div class="product-header">
                                    <div class="header-cell">{{"myMaterial.materialLabel" | cxTranslate}}</div>
                                    <div class="header-cell header-cell-qty">{{"myMaterial.qtyLabel" | cxTranslate}}</div>
                                  </div>
                                  @for( item of digitalMaterialsList;track item){
                                  <div class="product-row" >
                                    <div class="material_detail">
                                    <img [src]="getMedia(item.media)">
                                    <div class="product-name">{{item.headline}}<br>
                                        <div class="material_subtext">{{item.itemPerPack}}</div>
                                    </div>
                                    </div>
                                    <div class="material_qty">
                                        <div>{{item.itemQty}}</div>
                                    </div>
                                  </div>
                                }
                                </mat-expansion-panel>
                            }
                              @if(printedMaterialsList?.length > 0 ){
                                <mat-expansion-panel >
                                  <mat-expansion-panel-header>
                                    <mat-panel-title>{{"myMaterial.printedMatrLabel" | cxTranslate}}</mat-panel-title>
                                  </mat-expansion-panel-header>
                                  <div class="product-header">
                                    <div class="header-cell">{{"myMaterial.materialLabel" | cxTranslate}}</div>
                                    <div class="header-cell header-cell-qty">{{"myMaterial.qtyLabel" | cxTranslate}}</div>
                                  </div>
                                  @for(item of printedMaterialsList;track item){
                                  <div class="product-row" >
                                    <div class="material_detail">
                                    <img [src]="getMedia(item.media)">
                                    <div class="product-name">{{item.headline}}<br>
                                        <div class="material_subtext">{{item.itemPerPack}}</div>
                                        <div class="material_status" [ngClass]="item.stockAvailability != 'Available' ? 'red':''">{{item.stockAvailability}}</div>
                                    </div>
                                    </div>
                                    <div class="material_qty">
                                        <div>{{item.itemQty}}</div>
                                    </div>
                                  </div>
                                }
                                    
                                </mat-expansion-panel>
                            }
                              
                              </mat-accordion>
                              
                        </div>
@if(showDeliveries()){
                        <div  class="order_panel_header">
                        <div class="col-md-12  deliveriesClass order_id">{{"myMaterial.deliveryLabel" | cxTranslate}}</div>
                        <div class="col-md-12 no-padding">
                            <div id="openordershipmenttable_{{rightsectionresponse.materialsOrderData[0].orderId}}_wrapper" class="dataTables_wrapper shipping_history no-footer">
                               
                        <table mat-table  class="table order-details-table" [dataSource]="materialDeliveriesdataSource" >
                            
                            <ng-container matColumnDef="status">
                              <th mat-header-cell *matHeaderCellDef> {{"myMaterial.statusLabel" | cxTranslate}} </th>
                              <td mat-cell *matCellDef="let element"> {{element.status | lowercase}} </td>
                            </ng-container>
                          
                            <ng-container matColumnDef="deliveryDate">
                              <th mat-header-cell *matHeaderCellDef>{{"myMaterial.delDateLabel" | cxTranslate}} </th>
                              <td mat-cell *matCellDef="let element"> {{element.deliverydate}} </td>
                            </ng-container>
                          
                             <ng-container matColumnDef="items">
                              <th mat-header-cell *matHeaderCellDef>{{"myMaterial.itemsLabel" | cxTranslate}}</th>
                              <td mat-cell *matCellDef="let element"> <span [innerHTML]="element.items"></span> </td>
                            </ng-container>
                          
                            <ng-container  matColumnDef="trackingLink">
                                <th mat-header-cell *matHeaderCellDef> {{"myMaterial.trackDelLabel" | cxTranslate}}</th>
                              <td mat-cell *matCellDef="let element">
                                @if(element.trackingLink != 'NA'){
                                <a  [href]="element.trackingLink" target="_blank"><button class="global_greybtn">Track Delivery</button></a>
                                }
                              </td>
                            </ng-container>
                          
                            <tr mat-header-row *matHeaderRowDef="materialsDeliveryColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: materialsDeliveryColumns;"></tr>
                          </table>
                    </div>
                        </div>
                    </div>
                }

                    </div>
                </div>

            }
        </div>
    </div>
}
</div>

